
import Vue from "vue";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import {
  EnumHelper,
  FontTypeEnum,
  SchoolTemplateButtonTypeEnum,
} from "@/constants/enum.constant";

@Component
export default class App extends Vue {
  @Action("actionChangeColor")
  private actionChangeColor: any;
  @Action("getSchoolProfile", { namespace: "school" })
  private getSchoolProfile: any;
  @Action("getTemplate", { namespace: "school" })
  private getTemplate: any;

  private fontTypes = EnumHelper(FontTypeEnum);

  private created() {
    this.getSchoolProfile({
      success: (response: AxiosResponse) => {
        const docTitle = document.getElementById(
          "doc-title"
        ) as HTMLTitleElement | null;
        if (docTitle !== null) docTitle.text = response.data.data.name;
        if (!response.data.data.is_portal && (![
            "/register",
            "/partnership",
            "/set-password",
            "/takeover",
            "/tracer-study",
          ].find((v) => this.$route.path.startsWith(v)) ||
          (this.$route.params.actor && this.$route.path.includes("/reset/")))) {
          return window.open("https://career.support", "_self");
          
        }
        this.getTemplate({
          success: (response: AxiosResponse) => {
            let template = response.data.data;
            const docFavicon = document.querySelectorAll(
              "link[rel*='icon']"
            ) as any | null;
            if (docFavicon !== null)
              docFavicon.forEach(
                (value: any) => (value.href = response.data.data.logo)
              );
            if (template.font) {
              document.head.insertAdjacentHTML(
                "beforeend",
                `
                <style>
                    @import url("${template.font.url}");
                    * {
                        font-family: "${template.font.name}", ${this.fontTypes
                  .find((value) => value.id === template.font.type)
                  ?.name.replaceAll(" ", "-")};
                    }
                </style>
                `
              );
            }
            if (template.color_primary) {
              document.head.insertAdjacentHTML(
                "beforeend",
                `
                <style>
                    .color-primary {
                        color: ${template.color_primary} !important;
                    }
                    .bgc-primary {
                        background-color: ${template.color_primary} !important;
                    }
                    .bdr-primary {
                        border-width: 1px;
                        border-style: solid;
                        border-color: ${template.color_primary} !important;
                    }
                </style>
                `
              );
            }
            if (template.color_accent) {
              document.head.insertAdjacentHTML(
                "beforeend",
                `
                <style>
                    h1, h2, h3, h4, h5, h6, p, span {
                        color: ${template.color_accent} !important;
                    }
                </style>
                `
              );
            }
            if (template.button_type) {
              document.head.insertAdjacentHTML(
                "beforeend",
                `
                <style>
                    button, .btn-circle {
                        border-radius: ${
                          template.button_type ===
                          SchoolTemplateButtonTypeEnum.SHARP
                            ? 0
                            : template.button_type ===
                              SchoolTemplateButtonTypeEnum.ROUND
                            ? "12px"
                            : template.button_type ===
                              SchoolTemplateButtonTypeEnum.PILL
                            ? "24px"
                            : 0
                        } !important;
                        color: white;
                    }
                </style>
                `
              );
            }
          },
        });
      },
    });
  }
}
